import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const productCategoryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Product category',
    context: 'Name of a column in table of activity data',
  }),
  externalDescription: msg({
    message: 'The type of product',
    context: 'Description of a column in table of activity data',
  }),
};

export const productField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Sold product name',
    context: 'The display name for the sold product name field',
  }),
};

export const productIdField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Sold product ID',
    context: 'The display name for the sold product ID field',
  }),
  externalDescription: msg({
    message:
      'Unique way to identify the product (e.g. name, SKU, product key).',
    context: 'Sold product ID',
  }),
};

export const productQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Product quantity',
    context: 'The quantity of good sold.',
  }),
  externalDescription: msg({
    message: 'The quantity of good sold.',
    context: 'Product quantity',
  }),
};

export const productWeightField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Product weight',
    context: 'The weight of each order of product',
  }),
  externalDescription: msg({
    message: 'The weight of each order of product',
    context: 'Product weight',
  }),
};

export const productWeightUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Product weight unit',
    context: 'Name of a column in table of activity data',
  }),
  externalDescription: msg({
    message: 'The unit of the weight of each order of product',
    context: 'Description of a column in table of activity data',
  }),
};

export const isThirdPartyField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Is third party',
    context: 'Whether purchased by the company or by a third party.',
  }),
  externalDescription: msg({
    message: 'Whether purchased by the company or by a third party.',
    context: 'Is third party',
  }),
};

export const purchasedMaterialIdField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Purchased material ID',
    context: 'The display name for the purchased material ID field',
  }),
};

export const purchasedMaterialNameField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Purchased material name',
    context: 'The display name for the purchased material name field',
  }),
};

export const productFields = {
  product: productField,
  product_id: productIdField,
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const purchasedMaterialFields = {
  purchased_material_id: purchasedMaterialIdField,
  purchased_material_name: purchasedMaterialNameField,
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
